import React from 'react';
import './Table.css'; // Importing the CSS file

interface TableProps {
  items: {
    headings?: string[];
    rows: string[][];
  };
}

const Table: React.FC<TableProps> = ({ items }) => {
  const { headings, rows } = items;

  return (
    <div className="table-container">
      <table className="custom-table table-text-size">
        {/* Table Header */}
        <thead>
          <tr>
            {headings?.map((heading, index) => (
              <th key={index}>{heading}</th>
            ))}
          </tr>
        </thead>

        {/* Table Body */}
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>
                  {cell.includes('\n') ? (
                    cell.split('\n').map((item, index) => (
                      <React.Fragment key={index}>
                        {item}
                        <br />
                      </React.Fragment>
                    ))
                  ) : (
                    cell
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
